<template>
  <fieldset class="tab tab-10">
    <div class="heading-form a-center">
      <span class="number">10/11</span>
      <p class="c-yellow">ไลฟ์สไตล์ของคุณ</p>
      <h2 class="heading-h2 c-white">
        คุณเคยเข้าร่วมงานเดิน-วิ่งมาราธอนไหม บ่อยเพียงใด
      </h2>
    </div>
    <div class="icw-fieldset-inner">
      <ul class="icw-fields">
        <li class="icw-field icw-field-full">
          <div class="icw-input icw-input-checkbox" id="rdoMarathon">
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="walkrun"
                id="moreM2"
                class="css-checkbox"
                value="everymonth"
                v-model="run_rate"
              />
              <label for="moreM2" class="css-label">ทุกเดือน หรือมากกว่า</label>
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="walkrun"
                id="more2M2"
                class="css-checkbox"
                value="every2month"
                v-model="run_rate"
              />
              <label for="more2M2" class="css-label">ทุก 2 เดือน</label>
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="walkrun"
                id="more2Y2"
                class="css-checkbox"
                value="every2year"
                v-model="run_rate"
              />
              <label for="more2Y2" class="css-label">ปีละ 2-3 ครั้ง</label>
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="walkrun"
                id="moreY2"
                class="css-checkbox"
                value="everyyear"
                v-model="run_rate"
              />
              <label for="moreY2" class="css-label"
                >ปีละครั้ง หรือน้อยกว่า</label
              >
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="walkrun"
                id="none2"
                class="css-checkbox"
                value="-1"
                v-model="run_rate"
              />
              <label for="none2" class="css-label">ไม่เคยเข้าร่วม</label>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="icw-fieldset-action previous">
      <button
        type="button"
        class="btn btn-previous previous"
        @click="prevStep('tab-10', 'tab-09')"
      >
        ย้อนกลับ
      </button>
    </div>
    <button
      type="button"
      id="btnNextStepQ11"
      class="btn btn-next next"
      :class="{ 'btn-disabled': !isPass }"
      @click="beforeNextStep()"
    >
      ถัดไป
    </button>
  </fieldset>
</template>

<script>
import Vue from "vue";

import { my_storage, incCurrentStep } from "@/helpers/global_helper.js";
import { nextStep, prevStep } from "@/helpers/step_helper.js";

export default {
  name: "QuestionStep1_Q10",
  props: {
    QuestionType: String
  },
  data() {
    return {
      run_rate:
        my_storage(this.QuestionType, "run_rate") == ""
          ? []
          : my_storage(this.QuestionType, "run_rate")
    };
  },
  mounted() {},
  methods: {
    my_storage,
    nextStep,
    prevStep,
    beforeNextStep() {
      if (this.run_rate.length > 0) {
        sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data));

        let currentTag = this.$vnode.componentOptions.tag;
        currentTag = currentTag.replace("Q", "");
        incCurrentStep("step1", currentTag);

        this.isError = false;

        this.nextStep("tab-10", "tab-11");
      }
    }
  },
  computed: {
    isPass() {
      return this.run_rate.length > 0;
    }
  }
};
</script>
